import { Box, Icon } from '@chakra-ui/core';
import React from 'react';

const IconDot = props => {
  return (
    <Icon width={8} height={8} fill='currentColor' viewBox='0 0 8 8' {...props}>
      <circle cx={4} cy={4} r={4} />
    </Icon>
  );
};

const IconMenu = props => {
  return (
    <Box
      as='svg'
      width='1em'
      height='1em'
      viewBox='0 0 38 30'
      fill='currentColor'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 2a2 2 0 012-2h34a2 2 0 110 4H2a2 2 0 01-2-2zm0 13a2 2 0 012-2h34a2 2 0 110 4H2a2 2 0 01-2-2zm2 11a2 2 0 100 4h34a2 2 0 100-4H2z'
      />
    </Box>
  );
};

const IconClose = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 12 12'
      fill='currentColor'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.29289 6.00001L0 1.70712L1.41421 0.292908L5.70711 4.5858L10 0.292908L11.4142 1.70712L7.12132 6.00001L11.4142 10.2929L10 11.7071L5.70711 7.41423L1.41421 11.7071L0 10.2929L4.29289 6.00001Z'
      />
    </Icon>
  );
};

const IconHome = props => {
  return (
    <Icon viewBox='0 0 18 20' fill='currentColor' {...props}>
      <path d='M17.234 7.761L8.964.181a.69.69 0 00-.945.014L.21 7.775A.69.69 0 000 8.269v10.888c0 .38.308.69.69.69h5.742a.69.69 0 00.689-.69v-5.053h3.216v5.053c0 .38.308.69.689.69h5.742c.38 0 .69-.31.69-.69V8.269a.69.69 0 00-.224-.508zm-1.155 10.707h-4.364v-5.053a.69.69 0 00-.69-.69H6.433a.69.69 0 00-.69.69v5.053H1.379V8.561l7.135-6.925 7.566 6.936v9.896z' />
    </Icon>
  );
};

const IconUser = props => {
  return (
    <Icon viewBox='0 0 20 20' fill='currentColor' {...props}>
      <path d='M17.093 3.054A9.908 9.908 0 009.921 0C4.449-.007.007 4.424 0 9.896a9.908 9.908 0 003.054 7.167c.005.005.008.014.013.019.058.055.12.102.178.155.16.142.319.289.487.425.09.071.183.142.275.207.16.119.318.237.484.346l.344.213c.153.092.305.184.464.269.133.07.27.132.406.196.149.07.296.142.448.206.152.063.305.113.46.168.154.056.288.107.436.152.167.05.338.09.508.13.142.036.28.075.426.104.195.039.394.063.592.09.123.017.242.042.366.054.325.031.652.05.982.05.33 0 .658-.019.982-.05.125-.012.244-.037.367-.054.198-.027.397-.051.592-.09.142-.029.284-.071.425-.103.17-.042.342-.08.51-.131.147-.046.29-.1.435-.152.145-.05.309-.106.46-.168.15-.063.299-.136.448-.206.136-.064.272-.125.406-.196.158-.084.31-.177.464-.27.115-.07.231-.135.344-.212.166-.11.325-.227.483-.346.092-.07.186-.134.276-.207a9.19 9.19 0 00.487-.425c.058-.053.12-.1.178-.155.005-.005.008-.014.013-.02 3.952-3.785 4.086-10.057.3-14.008zM15.501 16.32a8.23 8.23 0 01-.637.504 7.81 7.81 0 01-.685.445l-.38.212a9.612 9.612 0 01-.715.328 7.2 7.2 0 01-.39.142c-.12.041-.24.084-.36.12-.142.042-.29.077-.437.113-.115.026-.228.057-.345.08-.167.032-.339.055-.511.078-.098.013-.195.03-.293.04a8.618 8.618 0 01-.827.042c-.278 0-.554-.015-.826-.041-.098-.01-.195-.028-.293-.04-.172-.024-.344-.047-.512-.08-.116-.022-.23-.052-.344-.08a9.799 9.799 0 01-.437-.112c-.12-.036-.24-.079-.36-.12a9.865 9.865 0 01-.39-.142 7.253 7.253 0 01-.37-.161 6.477 6.477 0 01-.725-.38 8.708 8.708 0 01-1.322-.948c-.031-.024-.06-.053-.09-.08a5.685 5.685 0 013.864-5.311 4.201 4.201 0 003.61 0 5.685 5.685 0 013.863 5.31c-.03.028-.058.055-.088.08zM7.45 5.68a2.834 2.834 0 113.86 3.86c-.004 0-.008 0-.013.004a3.003 3.003 0 01-.592.251c-.037.01-.07.025-.11.034-.07.019-.145.031-.218.044a2.872 2.872 0 01-.416.042h-.08a2.87 2.87 0 01-.417-.042c-.07-.013-.146-.025-.218-.044-.037-.009-.07-.023-.11-.034a3 3 0 01-.592-.25L8.53 9.54a2.834 2.834 0 01-1.081-3.86zm9.396 9.155a7.121 7.121 0 00-3.793-4.885 4.252 4.252 0 10-6.264 0 7.121 7.121 0 00-3.794 4.885A8.499 8.499 0 1118.424 9.92a8.448 8.448 0 01-1.578 4.916z' />
    </Icon>
  );
};

const IconBriefCase = props => {
  return (
    <Icon viewBox='0 0 24 20' fill='currentColor' {...props}>
      <path d='M21.923 3.692h-3.957l-1.272-2.544A2.066 2.066 0 0014.837 0H9.163C8.372 0 7.66.44 7.306 1.148L6.034 3.692H2.077A2.08 2.08 0 000 5.77v12a2.08 2.08 0 002.077 2.077h19.846A2.08 2.08 0 0024 17.77v-12a2.08 2.08 0 00-2.077-2.077zM8.544 1.767a.689.689 0 01.62-.382h5.673c.264 0 .5.146.619.382l.962 1.925H7.582l.962-1.925zm-4.62 16.694H2.076a.693.693 0 01-.692-.692V9.131l2.538 1.097v8.234zm14.768 0H5.308v-7.634l3.648 1.578c.087.037.18.056.275.056h.692v1.616c0 .636.518 1.154 1.154 1.154h1.846c.636 0 1.154-.518 1.154-1.154V12.46h.692c.095 0 .188-.019.275-.056l3.648-1.578v7.635zm-7.384-4.615v-1.385h1.384v1.385h-1.384zm11.307 3.923c0 .382-.31.693-.692.693h-1.846v-8.234l2.538-1.097v8.638zm0-10.147h-.002l-7.987 3.455H9.374l-7.99-3.455V5.77c0-.381.311-.692.693-.692h19.846c.382 0 .692.31.692.692v1.853z' />
    </Icon>
  );
};

const IconTicket = props => {
  return (
    <Icon viewBox='0 0 24 15' fill='currentColor' {...props}>
      <path d='M23.15 14.206v-3.673a.678.678 0 00-.4-.619 2.715 2.715 0 01-1.6-2.472c0-1.064.627-2.034 1.6-2.472.243-.11.4-.351.4-.618V.678A.678.678 0 0022.47 0H.678A.678.678 0 000 .678v3.674c0 .267.156.509.4.618A2.715 2.715 0 012 7.442 2.715 2.715 0 01.4 9.914a.678.678 0 00-.4.619v3.673c0 .375.303.679.678.679h21.793a.678.678 0 00.678-.679zm-1.357-12.85v2.585a4.075 4.075 0 00-2 3.501c0 1.446.772 2.777 2 3.502v2.584h-4.278V1.356h4.278zM1.356 13.528v-2.584a4.074 4.074 0 002-3.502 4.075 4.075 0 00-2-3.501V1.356h14.802v12.172H1.356z' />
    </Icon>
  );
};

const IconCalendar = props => {
  return (
    <Icon viewBox='0 0 16 16' fill='currentColor' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.571 1.714h1.715c.947 0 1.714.768 1.714 1.715v10.857c0 .947-.768 1.714-1.714 1.714H1.714A1.714 1.714 0 010 14.286V3.429c0-.947.768-1.715 1.714-1.715H3.43V.571a.571.571 0 011.142 0v1.143h6.858V.571a.571.571 0 111.142 0v1.143zm1.715 13.143a.571.571 0 00.571-.571V6H1.143v8.286c0 .315.256.571.571.571h12.572zM1.143 5.714h13.714V3.43a.571.571 0 00-.571-.572h-1.714V4a.571.571 0 01-1.143 0V2.857H4.57V4A.571.571 0 113.43 4V2.857H1.714a.571.571 0 00-.571.572v2.285z'
      />
      <rect x={3} y={8} width={4} height={1.5} rx={0.75} />
      <rect x={3} y={11.5} width={4} height={1.5} rx={0.75} />
      <rect x={9} y={8} width={4} height={1.5} rx={0.75} />
      <rect x={9} y={11.5} width={4} height={1.5} rx={0.75} />
      <path d='M1 2h14v4H1z' />
    </Icon>
  );
};

const IconChevronDown = props => {
  return (
    <Icon viewBox='0 0 19 12' fill='currentColor' {...props}>
      <path
        clipRule='evenodd'
        d='M0 1.414L1.414 0l8.25 8.25L16.96.043l1.494 1.328-8.704 9.793L0 1.414z'
      />
    </Icon>
  );
};

const IconLocation = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 25 25'
      fill='currentColor'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.226 9.722c0 .864-.288 1.96-.903 3.26-.607 1.28-1.467 2.626-2.454 3.952-1.312 1.765-2.78 3.406-4.022 4.713-1.241-1.307-2.71-2.948-4.022-4.713-.986-1.326-1.847-2.672-2.453-3.953-.615-1.3-.903-2.395-.903-3.259a7.378 7.378 0 1114.757 0zm2.343 0c0 4.496-4.868 10.226-8.083 13.603a93.99 93.99 0 01-1.631 1.667l-.008.008-.013-.013a94.686 94.686 0 01-1.626-1.662c-3.215-3.377-8.083-9.107-8.083-13.603C3.125 4.352 7.478 0 12.847 0c5.37 0 9.722 4.353 9.722 9.722zM12.847 12.5a2.778 2.778 0 100-5.556 2.778 2.778 0 000 5.556z'
      />
    </Icon>
  );
};

const IconCurrency = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 16 16'
      fill='currentColor'
      {...props}
    >
      <path d='M12.4356 13.234C11.6916 13.742 10.8717 14 9.99968 14C8.15775 14 6.5618 12.784 5.69584 11H8.99972C9.5517 11 9.99968 10.552 9.99968 10C9.99968 9.448 9.5517 9 8.99972 9H5.08386C5.03786 8.674 4.99986 8.342 4.99986 8C4.99986 7.658 5.03786 7.326 5.08386 7H9.99968C10.5517 7 10.9996 6.552 10.9996 6C10.9996 5.448 10.5517 5 9.99968 5H5.69584C6.5618 3.216 8.15775 2 9.99968 2C10.8717 2 11.6916 2.258 12.4356 2.766C12.8916 3.076 13.5156 2.962 13.8255 2.504C14.1375 2.048 14.0195 1.426 13.5636 1.114C12.4956 0.386 11.2636 0 9.99968 0C7.06979 0 4.56188 2.074 3.51991 5H1.99996C1.44798 5 1 5.448 1 6C1 6.552 1.44798 7 1.99996 7H3.08793C3.05193 7.332 2.99993 7.658 2.99993 8C2.99993 8.342 3.05193 8.668 3.08793 9H1.99996C1.44798 9 1 9.448 1 10C1 10.552 1.44798 11 1.99996 11H3.51991C4.56188 13.926 7.06979 16 9.99968 16C11.2636 16 12.4956 15.614 13.5636 14.886C14.0195 14.574 14.1375 13.952 13.8255 13.496C13.5156 13.04 12.8916 12.924 12.4356 13.234Z' />
    </Icon>
  );
};

const IconTime = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 16 16'
      fill='currentColor'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 8a8 8 0 018-8 8.009 8.009 0 018 8A8 8 0 110 8zm1.143 0A6.857 6.857 0 008 14.857 6.865 6.865 0 0014.857 8 6.857 6.857 0 001.143 8zm6.285-4.571a.571.571 0 111.143 0V8a.571.571 0 01-.572.572H3.428a.571.571 0 110-1.143h4v-4z'
      />
    </Icon>
  );
};

const IconExperience = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 16 16'
      fill='currentColor'
      {...props}
    >
      <path d='M.163 11.373c-.071 0-.122-.019-.153-.057-.02-.047-.01-.099.03-.155l2.464-3.376c.02-.028.02-.056 0-.084L.041 4.325a.214.214 0 01-.03-.099c0-.075.05-.113.152-.113h1.913c.091 0 .163.038.214.113l1.377 1.935c.04.057.076.057.107 0l1.377-1.935a.244.244 0 01.214-.113h2.05c.072 0 .118.024.138.07.02.038.01.085-.03.142L5.073 7.7a.121.121 0 000 .084l2.448 3.376c.02.028.031.061.031.099 0 .075-.046.113-.138.113H5.488a.244.244 0 01-.215-.113L3.896 9.325c-.03-.057-.06-.057-.091 0L2.428 11.26a.244.244 0 01-.215.113H.163zM15.725 6.062c.183.48.275 1.045.275 1.695 0 .65-.097 1.238-.29 1.766a3.082 3.082 0 01-1.118 1.44c-.5.349-1.122.523-1.866.523-.735 0-1.306-.236-1.714-.706-.02-.029-.04-.038-.061-.029-.02.01-.03.029-.03.057v3.023c0 .047-.021.084-.062.113a.15.15 0 01-.122.056h-1.79a.198.198 0 01-.138-.056.146.146 0 01-.046-.114V4.283c0-.047.015-.084.046-.113a.198.198 0 01.138-.056h1.79a.15.15 0 01.122.056c.041.029.061.066.061.113v.467c0 .028.01.047.031.056.02 0 .04-.01.061-.028.429-.518 1.02-.777 1.775-.777.704 0 1.31.184 1.82.55.52.359.893.862 1.118 1.512zm-2.341 3.164c.255-.367.382-.866.382-1.497 0-.593-.107-1.064-.321-1.413-.235-.405-.612-.607-1.132-.607-.47 0-.821.202-1.056.607-.214.34-.321.815-.321 1.427 0 .63.112 1.12.336 1.469.235.377.582.565 1.04.565.46 0 .817-.184 1.072-.551z' />
    </Icon>
  );
};

const IconCog = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 16 16'
      fill='currentColor'
      {...props}
    >
      <path d='M15.603 6.512l-1.428-.172a6.378 6.378 0 00-.635-1.536l.888-1.129a.463.463 0 00-.036-.597L12.92 1.606a.464.464 0 00-.597-.037l-1.13.89a6.288 6.288 0 00-1.534-.634L9.488.397A.464.464 0 009.04 0H6.959a.462.462 0 00-.448.397L6.34 1.825c-.544.145-1.06.36-1.535.634l-1.13-.888a.464.464 0 00-.597.036L1.606 3.08a.464.464 0 00-.034.597l.887 1.13a6.322 6.322 0 00-.634 1.535l-1.428.171A.463.463 0 000 6.961v2.081c0 .22.179.42.397.448l1.428.171a6.36 6.36 0 00.635 1.533l-.888 1.13a.465.465 0 00.037.598l1.47 1.473a.464.464 0 00.597.036l1.13-.89c.476.276.99.49 1.534.635l.172 1.427a.462.462 0 00.447.397h2.082c.22 0 .421-.178.447-.397l.172-1.427a6.354 6.354 0 001.534-.634l1.13.888c.174.135.442.12.598-.036l1.471-1.473a.464.464 0 00.036-.598l-.889-1.13c.276-.475.49-.99.635-1.533l1.428-.172A.462.462 0 0016 9.041V6.96a.461.461 0 00-.397-.448zm-7.602 5.487A4 4 0 118 4a4 4 0 010 8z' />
    </Icon>
  );
};

const IconSearch = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 25 25'
      fill='currentColor'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.943 9.684c0 3.968-3.229 7.198-7.228 7.198-4 0-7.228-3.23-7.228-7.198 0-3.967 3.229-7.197 7.228-7.197 4 0 7.228 3.23 7.228 7.197zm-2.511 8.469a9.695 9.695 0 01-4.717 1.216C4.35 19.369 0 15.033 0 9.684 0 4.336 4.35 0 9.715 0s9.715 4.336 9.715 9.684a9.625 9.625 0 01-2.14 6.065l5.666 6.119a1.865 1.865 0 01-2.737 2.535l-5.787-6.25z'
      />
    </Icon>
  );
};

const IconFilters = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 26 25'
      fill='currentColor'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.542 2.693h15.199a1.259 1.259 0 110 2.518H9.542C9.04 6.678 7.686 7.73 6.094 7.73c-1.592 0-2.946-1.051-3.448-2.518H1.259a1.259 1.259 0 010-2.518h1.387C3.148 1.226 4.502.175 6.094.175c1.592 0 2.946 1.051 3.448 2.518zM0 12.345c0-.695.564-1.259 1.259-1.259h16.012c.502-1.467 1.856-2.518 3.448-2.518 1.592 0 2.946 1.051 3.448 2.518h.574a1.259 1.259 0 010 2.518h-.574c-.502 1.467-1.856 2.518-3.448 2.518-1.592 0-2.947-1.05-3.449-2.518H1.26A1.259 1.259 0 010 12.345zm1.259 7.134a1.259 1.259 0 000 2.518h7.887c.502 1.467 1.856 2.518 3.448 2.518 1.592 0 2.946-1.05 3.448-2.518h8.699a1.259 1.259 0 100-2.518h-8.699c-.502-1.467-1.856-2.518-3.448-2.518-1.592 0-2.947 1.051-3.448 2.518H1.259zM6.094 6.05c1.122 0 2.031-.939 2.031-2.098 0-1.159-.91-2.098-2.031-2.098-1.122 0-2.032.94-2.032 2.098 0 1.159.91 2.098 2.032 2.098zm14.625 8.393c1.122 0 2.031-.939 2.031-2.098 0-1.159-.91-2.098-2.031-2.098-1.122 0-2.032.94-2.032 2.098 0 1.159.91 2.098 2.032 2.098zm-6.094 6.295c0 1.16-.91 2.099-2.031 2.099-1.122 0-2.031-.94-2.031-2.099 0-1.159.909-2.098 2.03-2.098 1.123 0 2.032.94 2.032 2.098z'
      />
    </Icon>
  );
};

const IconArrowLeft = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 18 16'
      fill='currentColor'
      {...props}
    >
      <path d='M17 9a1 1 0 100-2v2zM.293 7.293a1 1 0 000 1.414l6.364 6.364a1 1 0 001.414-1.414L2.414 8l5.657-5.657A1 1 0 006.657.93L.293 7.293zM17 7H1v2h16V7z' />
    </Icon>
  );
};

const IconEnvelop = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 24 18'
      fill='currentColor'
      {...props}
    >
      <path d='M21.89 0H2.11C.947 0 0 .932 0 2.077v13.846C0 17.064.944 18 2.11 18h19.78c1.16 0 2.11-.929 2.11-2.077V2.077C24 .936 23.056 0 21.89 0zm-.29 1.385l-9.555 9.407-9.638-9.407H21.6zM1.405 15.636V2.357L8.18 8.968l-6.773 6.668zm.995.98l6.776-6.673 2.375 2.318a.71.71 0 00.992-.002l2.315-2.28 6.74 6.636H2.401zm20.193-.98L15.854 9l6.74-6.636v13.272z' />
    </Icon>
  );
};

const IconCheck = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      fill='currentColor'
      {...props}
    >
      <path d='M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z' />
    </Icon>
  );
};

const IconFacebook = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 28 28'
      fill='currentColor'
      {...props}
    >
      <path d='M20.534 1.665a6.019 6.019 0 016.008 6.02v12.85a6.02 6.02 0 01-6.01 6.01H18.81v-5.874h2.72l.203-1.435.468-3.291.27-1.905h-3.663v-2.305-.077H18.953l1.905-.015 1.655-.014V5.278l-1.44-.2c-.998-.109-2.003-.161-3.009-.157a6.308 6.308 0 00-4.542 1.71 6.457 6.457 0 00-1.793 4.738v2.671H8.6v6.63h3.124v5.874h-4.04a6.019 6.019 0 01-6.018-6.009V7.685a6.02 6.02 0 016.019-6.02h12.85zm0-1.665H7.684A7.701 7.701 0 000 7.684v12.851a7.703 7.703 0 007.684 7.684h5.713v-9.218h-3.128v-3.292h3.123V11.37a4.37 4.37 0 014.665-4.78c.928-.004 1.857.043 2.78.141v3.234l-1.904.016c-1.515 0-1.793.703-1.793 1.748v3.98h3.409l-.468 3.292h-2.945v9.213h3.392a7.702 7.702 0 007.684-7.684V7.684A7.703 7.703 0 0020.528 0h.006z' />
    </Icon>
  );
};

const IconTwitter = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 29 29'
      fill='currentColor'
      {...props}
    >
      <path d='M17.12 9.25a2.769 2.769 0 012.028.878 7.222 7.222 0 001.763-.67c-.216.609-.61 1.14-1.13 1.524a10.576 10.576 0 001.508-.424 3.244 3.244 0 01-1.392 1.434c.009.121.009.24.009.361 0 4.11-1.296 7.906-7.508 7.906h-.386a7.707 7.707 0 01-4.262-1.247 10.43 10.43 0 004.116-1.156A2.78 2.78 0 019.27 15.93c.173.027.348.04.524.042.246 0 .492-.032.73-.094a2.777 2.777 0 01-2.226-2.726v-.033c.385.214.814.334 1.254.351a2.78 2.78 0 01-.859-3.713 7.892 7.892 0 005.724 2.904 3.15 3.15 0 01-.068-.635 2.777 2.777 0 012.776-2.777l-.005.002zm5.805-2.231l-3.431 1.384a4.329 4.329 0 00-6.532 2.44A11.578 11.578 0 018.54 7.356a8.747 8.747 0 00-1.797 5.768v.033c0 .903.284 1.784.81 2.517a2.99 2.99 0 00.688 1.71c-.44.104-2.926.642-3.457.758 1.366 2.733 5.147 3.617 7.19 3.667h.428c3.346 0 5.81-1.02 7.319-3.032a10.053 10.053 0 001.73-5.973 6.486 6.486 0 002-4.26l-.95.319.425-1.844z' />
      <path d='M20.704 28.294H7.581A7.59 7.59 0 010 20.71V7.583A7.593 7.593 0 017.581 0h13.123a7.59 7.59 0 017.581 7.583V20.71a7.594 7.594 0 01-7.58 7.585zM7.581 1.724a5.864 5.864 0 00-5.858 5.86v13.125a5.867 5.867 0 005.858 5.86h13.123a5.864 5.864 0 005.858-5.86V7.583a5.867 5.867 0 00-5.858-5.86H7.581z' />
    </Icon>
  );
};

const IconInstagram = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 28 28'
      fill='currentColor'
      {...props}
    >
      <path d='M20.704 28.294H7.581A7.59 7.59 0 010 20.71V7.583A7.593 7.593 0 017.581 0h13.123a7.59 7.59 0 017.581 7.583V20.71a7.594 7.594 0 01-7.58 7.585zM7.581 1.724a5.864 5.864 0 00-5.858 5.86v13.125a5.867 5.867 0 005.858 5.86h13.123a5.864 5.864 0 005.858-5.86V7.583a5.867 5.867 0 00-5.858-5.86H7.581z' />
      <path d='M14.143 21.205a7.053 7.053 0 01-6.918-8.432 7.056 7.056 0 019.617-5.142 7.054 7.054 0 012.287 11.505 7.06 7.06 0 01-4.986 2.069zm0-12.387a5.33 5.33 0 00-5.228 6.373 5.332 5.332 0 007.268 3.886 5.33 5.33 0 001.728-8.696c-.999-1-2.354-1.562-3.768-1.564v.001zM21.983 4.45a1.895 1.895 0 100 3.79 1.895 1.895 0 000-3.79z' />
    </Icon>
  );
};

const IconLogout = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      {...props}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'
      />
    </Icon>
  );
};

const IconEyeOpened = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 32 32'
      fill='currentColor'
      stroke='none'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30 16s-4-6-14-6-14 6-14 6 4 6 14 6 14-6 14-6zM3.96 16a12.964 12.964 0 002.122 1.752c1.652 1.101 4.096 2.235 7.48 2.615A4.999 4.999 0 0111 16a4.999 4.999 0 012.563-4.367c-3.386.38-5.829 1.514-7.481 2.615A12.964 12.964 0 003.96 16zm21.958 1.752c-1.652 1.101-4.095 2.235-7.48 2.615a4.999 4.999 0 002.475-5.302L17 15.5l2.967-2.543a5.023 5.023 0 00-1.53-1.324c3.386.38 5.829 1.514 7.48 2.615.957.638 1.656 1.27 2.123 1.752a12.962 12.962 0 01-2.122 1.752z'
      />
    </Icon>
  );
};

const IconEyeClosed = props => {
  return (
    <Icon
      width='1em'
      height='1em'
      viewBox='0 0 32 32'
      fill='currentColor'
      stroke='none'
      {...props}
    >
      <path d='M11.54 10.434C4.791 11.813 2 16 2 16s4 6 14 6h.081c.262.002.56.01.868.017l.388.01-4.812-9.623a4.998 4.998 0 001.037 7.962c-3.384-.38-5.828-1.513-7.48-2.614A12.963 12.963 0 013.96 16a12.6 12.6 0 011.562-1.359c1.45-1.071 3.642-2.255 6.715-2.814l-.697-1.393zM19.23 24.638a.996.996 0 001.217.256 1 1 0 00.447-1.341l-.944-1.89-5.797-11.593-1.259-2.517a1.001 1.001 0 00-1.341-.447 1 1 0 00-.447 1.341l8 16c.034.07.076.134.124.191zM14.694 10.035l5.766 11.53C27.209 20.188 30 16 30 16s-4-6-14-6c-.447 0-.882.012-1.306.035z' />
    </Icon>
  );
};

export {
  IconArrowLeft,
  IconBriefCase,
  IconCheck,
  IconCalendar,
  IconChevronDown,
  IconClose,
  IconCog,
  IconCurrency,
  IconDot,
  IconEnvelop,
  IconExperience,
  IconEyeOpened,
  IconEyeClosed,
  IconFacebook,
  IconFilters,
  IconHome,
  IconInstagram,
  IconMenu,
  IconLocation,
  IconLogout,
  IconSearch,
  IconTicket,
  IconTime,
  IconTwitter,
  IconUser
};
